module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "ch1",
      "title": "Can a Cockroach Survive a Nuclear Bomb?"
    }
  }, [_c('p', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#rch1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("Can a Cockroach Survive a Nuclear Bomb?")])])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "193",
      "src": "images/f008.jpg",
      "width": "231"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cockroaches are resilient creatures that have lived on earth for 300 million years, predating the dinosaurs by 150 million years. After atomic bombs were dropped on Hiroshima and Nagasaki in 1945, reports later emerged that the only survivors in the cities were cockroaches, whose populations seemed largely unaffected. This led many to believe that roaches can survive nuclear bombs. So, can they, or is this just another urban myth?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To test this theory, various scientific teams have conducted experiments on cockroaches over the last 60 years, exposing them to the radioactive metal cobalt-60, a synthetic substance produced artificially in nuclear reactors. After an exposure of 1,000 radon units (rads), which was the level of radiation detected about 15 miles from Hiroshima directly after the bomb was detonated, capable of killing a person in 10 minutes, most cockroaches survived, although their fertility was severely compromised. After exposure to 10,000 rads, the amount of radiation emitted by the Hiroshima bomb, only one in ten cockroaches survived, and at a level of 100,000 rads, no cockroaches lived.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ability of cockroaches to withstand extreme radiation owes to the simple design of their bodies and their relatively slow cell cycles. Cells are most sensitive to radiation when they’re dividing. The cells of a cockroach divide about every two days, and the insects molt only once a week. The cells of humans, on the other hand, are constantly changing and renewing, making us 10 times more susceptible to radiation than cockroaches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cockroaches, however, are nuclear lightweights compared with others in the insect world. It takes 64,000 rads to kill the fruit fly, 100,000 rads to kill the flour beetle, and the Habrobracon, a type of parasitic wasp, can withstand an astonishing 180,000 rads.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In short, while cockroaches would not be able to withstand the direct impact of an explosion, some would be able to survive the radiation produced by a blast on the level of the Hiroshima bomb. They wouldn’t survive the far more powerful bombs of today, but they’re still impressively hardy bugs. This begs the question: Just how strong is the stuff they put in bug spray, anyway?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b81305f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter001.vue
// module id = 72
// module chunks = 0